
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/procedure",
      function () {
        return require("private-next-pages/procedure.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/procedure"])
      });
    }
  